import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHeart,
  faUserFriends,
  faAward,
  faCalendarAlt,
  faStar,
  faGem,
  faSmile,
} from "@fortawesome/free-solid-svg-icons";
import "../../../styles/pages/about.css";

// Uvoz slika (zamijenite ove putanje sa stvarnim putanjama do vaših slika)
import aboutHeroImage from "../../../images/about/onama-mission.jpg";
import aboutTeamImage from "../../../images/about/onama-quality.jpg";

const About: React.FC = () => {
  // Efekt za animaciju elemenata na scroll
  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll(".animate-on-scroll");
      elements.forEach((element) => {
        const position = element.getBoundingClientRect();
        // Provjera je li element vidljiv na ekranu
        if (position.top < window.innerHeight - 100) {
          element.classList.add("animate-visible");
        }
      });
    };

    // Inicijalna provjera vidljivih elemenata
    handleScroll();

    // Dodavanje i uklanjanje event listenera
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="about-page">
      {/* Hero sekcija */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content">
            <h1 className="about-hero-title">O nama</h1>
            <p className="about-hero-description">
              Dobrodošli u Beauty Concept Veronika, gdje vaša ljepota dolazi do
              izražaja.
            </p>
          </div>
        </div>
        <div className="hero-wave">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,256L48,240C96,224,192,192,288,181.3C384,171,480,181,576,197.3C672,213,768,235,864,224C960,213,1056,171,1152,154.7C1248,139,1344,149,1392,154.7L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            ></path>
          </svg>
        </div>
      </section>

      {/* Glavna sekcija o nama */}
      <section className="about-main">
        <div className="container">
          <div className="about-content">
            <div className="about-image-container animate-on-scroll">
              <img
                src={aboutHeroImage}
                alt="Beauty Concept Veronika studio"
                className="about-image"
                loading="lazy"
              />
              {/* Uklonjena oznaka "7+ godina iskustva" kako je traženo */}
            </div>

            <div className="about-text-container animate-on-scroll">
              <div className="section-header">
                <span className="section-subtitle">Naša priča</span>
                <h2 className="section-title">Naša strast prema trepavicama</h2>
              </div>

              <div className="about-text">
                <p>
                  U Beauty Concept Veronika vjerujemo da su oči ogledalo duše, a
                  trepavice njihov najljepši okvir. Naša strast prema
                  trepavicama vodi nas u svakom tretmanu koji pružamo. Koristimo
                  najkvalitetnije materijale i najnovije tehnike kako bismo
                  osigurali da vaše trepavice izgledaju besprijekorno.
                </p>
                <p>
                  Bez obzira želite li suptilan, prirodan izgled ili dramatičan
                  efekt, prilagođavamo naše usluge vašim željama. Naš cilj je da
                  se osjećate lijepo i samopouzdano svaki dan.
                </p>
              </div>

              <div className="about-testimonial">
                <div className="testimonial-stars">
                  {[...Array(5)].map((_, i) => (
                    <FontAwesomeIcon key={i} icon={faStar} />
                  ))}
                </div>
                <p>
                  "Najbolje trepavice u gradu! Uvijek izađem presretna s
                  rezultatom."
                </p>
                <span className="testimonial-author">
                  — Zadovoljna klijentica
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Naše vrijednosti */}
      <section className="about-values">
        <div className="container">
          <div className="section-header text-center animate-on-scroll">
            <span className="section-subtitle">Naše vrijednosti</span>
            <h2 className="section-title">Što nas čini posebnima</h2>
          </div>

          <div className="values-grid">
            <div
              className="value-card animate-on-scroll"
              style={{ animationDelay: "0.1s" }}
            >
              <div className="value-icon">
                <FontAwesomeIcon icon={faHeart} />
              </div>
              <h3 className="value-title">Strast prema ljepoti</h3>
              <p className="value-description">
                Naša ljubav prema poslu vidljiva je u svakom tretmanu koji
                pružamo. Posvećeni smo isticanju vaše prirodne ljepote.
              </p>
            </div>

            <div
              className="value-card animate-on-scroll"
              style={{ animationDelay: "0.3s" }}
            >
              <div className="value-icon">
                <FontAwesomeIcon icon={faUserFriends} />
              </div>
              <h3 className="value-title">Individualni pristup</h3>
              <p className="value-description">
                Svaka osoba je jedinstvena, i mi to razumijemo. Zato posvećujemo
                vrijeme da upoznamo vas i vaše želje prije svakog tretmana.
              </p>
            </div>

            <div
              className="value-card animate-on-scroll"
              style={{ animationDelay: "0.5s" }}
            >
              <div className="value-icon">
                <FontAwesomeIcon icon={faAward} />
              </div>
              <h3 className="value-title">Kvaliteta i sigurnost</h3>
              <p className="value-description">
                Koristimo samo provjerene i visokokvalitetne proizvode koji su
                sigurni za vaše oči i trepavice, uz najviše higijenske
                standarde.
              </p>
            </div>
          </div>
        </div>
        <div className="section-wave">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="#ffffff"
              fillOpacity="1"
              d="M0,160L48,144C96,128,192,96,288,101.3C384,107,480,149,576,176C672,203,768,213,864,208C960,203,1056,181,1152,170.7C1248,160,1344,160,1392,160L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            ></path>
          </svg>
        </div>
      </section>

      {/* Naš pristup */}
      <section className="about-approach">
        <div className="container">
          <div className="approach-content">
            <div className="approach-text animate-on-scroll">
              <div className="section-header">
                <span className="section-subtitle">Naš pristup</span>
                <h2 className="section-title">
                  Individualni pristup svakoj klijentici
                </h2>
              </div>

              <p className="approach-description">
                Svaka osoba je jedinstvena, i mi to razumijemo. Zato posvećujemo
                vrijeme da upoznamo vas i vaše želje prije svakog tretmana. Naš
                individualni pristup osigurava da ćete dobiti rezultate koji
                najbolje odgovaraju vašem licu i stilu.
              </p>

              <p className="approach-description">
                Naša stručnost u ekstenzijama trepavica i lash lift tretmanima
                omogućuje nam da pružimo usluge koje će istaknuti vašu prirodnu
                ljepotu na najljepši način.
              </p>

              <div className="approach-list">
                <div
                  className="approach-item animate-on-scroll"
                  style={{ animationDelay: "0.1s" }}
                >
                  <div className="approach-item-icon">
                    <FontAwesomeIcon icon={faUserFriends} />
                  </div>
                  <div className="approach-item-text">
                    <h4>Konzultacije prije tretmana</h4>
                    <p>Detaljno razgovaramo o vašim željama i potrebama</p>
                  </div>
                </div>

                <div
                  className="approach-item animate-on-scroll"
                  style={{ animationDelay: "0.3s" }}
                >
                  <div className="approach-item-icon">
                    <FontAwesomeIcon icon={faGem} />
                  </div>
                  <div className="approach-item-text">
                    <h4>Personalizirani tretmani</h4>
                    <p>Svaki tretman je prilagođen vašoj jedinstvenoj pojavi</p>
                  </div>
                </div>

                <div
                  className="approach-item animate-on-scroll"
                  style={{ animationDelay: "0.5s" }}
                >
                  <div className="approach-item-icon">
                    <FontAwesomeIcon icon={faAward} />
                  </div>
                  <div className="approach-item-text">
                    <h4>Kontinuirano usavršavanje</h4>
                    <p>
                      Redovito se educiramo o najnovijim tehnikama i trendovima
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="approach-image animate-on-scroll">
              <img
                src={aboutTeamImage}
                alt="Naš profesionalni tim"
                loading="lazy"
              />
              <div className="image-decoration"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Kvaliteta */}
      <section className="about-quality">
        <div className="container">
          <div className="quality-content">
            <div className="section-header text-center animate-on-scroll">
              <span className="section-subtitle">Naša obećanja</span>
              <h2 className="section-title">
                Kvaliteta i sigurnost na prvom mjestu
              </h2>
            </div>

            <p className="quality-description text-center animate-on-scroll">
              Vaša sigurnost i zadovoljstvo su nam najvažniji. Koristimo samo
              provjerene i visokokvalitetne proizvode koji su sigurni za vaše
              oči i trepavice. Pridržavamo se najviših higijenskih standarda
              kako bismo osigurali ugodno i sigurno iskustvo za svaku
              klijenticu.
            </p>
            <p className="quality-description text-center animate-on-scroll">
              Naš tim je educiran i certificiran za sve usluge koje pružamo,
              tako da možete biti sigurni da ste u dobrim rukama.
            </p>

            <div className="quality-badges animate-on-scroll">
              <div className="quality-badge">
                <FontAwesomeIcon icon={faSmile} className="badge-icon" />
                <span>100% zadovoljstvo</span>
              </div>
              <div className="quality-badge">
                <FontAwesomeIcon icon={faGem} className="badge-icon" />
                <span>Premium proizvodi</span>
              </div>
            </div>
          </div>
        </div>
        <div className="quality-wave">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="#f8f9fa"
              fillOpacity="1"
              d="M0,96L48,101.3C96,107,192,117,288,138.7C384,160,480,192,576,186.7C672,181,768,139,864,138.7C960,139,1056,181,1152,186.7C1248,192,1344,160,1392,144L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            ></path>
          </svg>
        </div>
      </section>

      {/* CTA Sekcija */}
      <section className="about-cta">
        <div className="container">
          <div className="cta-content animate-on-scroll">
            <h2 className="cta-title">Iskusite razliku</h2>
            <p className="cta-description">
              Spremni ste istaknuti svoju prirodnu ljepotu? Rezervirajte svoj
              termin još danas i prepustite se stručnim rukama našeg tima.
            </p>
            <Link to="/booking" className="cta-button">
              <FontAwesomeIcon icon={faCalendarAlt} className="button-icon" />
              Rezervirajte termin
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
